app.views.payment = app.views.base.extend({
  cart: new Object(),
  childEvents: {
    'change [data-payment-frequency]': 'onChangePaymentFrequency',
    'change [data-clearbalance]': 'onChangePaymentPayInFull',
    'change [data-payment-startdate]': 'onChangePaymentStartDate',
    'change [data-billing-expirymonth]': 'onChangePaymentExpiryDate',
    'change [data-billing-expiryyear]': 'onChangePaymentExpiryDate',
    'change [data-source-of-funds]': 'onChangeSourceOfFunds',
    'click  [data-affordability-question-option]': 'onChangeAffordabilityQuestion',
    'click  [data-bank-account-question]': 'onChangeBankAccountQuestions',
    'click  [data-cpa-agreement-check]': 'onChangePaymentAgreement',
    'click  [data-postcode-search]': 'onSearchAddressesByPostcode',
    'click  [data-manual-address]': 'onToggleManuallyAddAddress',
    'click  [data-customer-address-toggle]': 'onToggleChangeBillingAddress',
    'change  [data-address-selection]': 'onAddressSelection',
    'keyup [data-postcode-search-box]': 'onSearchPostcodeChange',
    'click [data-payment-adjustment-confirm]': 'onPaymentSummaryRequestNext',
    'click [data-card-details-change]': 'onChangePaymentCard',
    'click [data-opayopi-singlepayment]': 'onOPayoSinglePayment',
    'click [data-customer-offer-reject]': 'onCustomerOfferRejected',
    'change [data-assessment-iande-question]': 'onChangeIandEQuestion',
    'change [data-assessment-di-question]': 'onChangeDIQuestion',
    'click [data-affordability-assessment-confirm]': 'onConfirmAffordability',
    'click [data-affordability-assessment-previous]': 'onPreviousAffordability',
    'change [data-di-amount-value]': 'onChangeDIValue',
    'change [data-confirm-unable-to-determine]': 'onConfirmUnabletoDetermine',
    'blur [data-single-payment-amount]': 'onChangeSinglePaymentAmount',
    'keyup [data-single-payment-amount]': 'onChangeSinglePaymentAmount'
  },
  attr: {
    formSubmit: 'data-payment-confirm',
    clearBalanceButton: 'data-clearbalance',
    affordability: 'data-affordability',
    affordabilityOptions: 'data-affordability-options',
    affordabilityOption: 'data-affordability-option',
    action: 'data-action',
    billWarning: 'data-bill-warning',
    postcodeSearchBtn: 'data-postcode-search',
    postcodeSearchBox: 'data-postcode-search-box',
    noAddressOptions: 'data-no-address-options',
    manualAddressEntry: 'data-manual-address-entry',
    manualAddressToggle: 'data-manual-address-toggle',
    notCustomerAddressToggle: 'data-customer-address-not-used',
    addressOptionsList: 'data-address-options',
    billingDisplayAddress: 'data-billing-display-address',
    addressSelectList: 'data-address-selection',
    postcodeValidationsErrors: 'data-postcode-validation-errors',
    billingAddressLine1: 'data-billing-addressline1',
    billingAddressLine2: 'data-billing-addressline2',
    billingAddressLine3: 'data-billing-addressline3',
    billingAddressCity: 'data-billing-city',
    billingAddressPostcode: 'data-billing-postcode',
    billingAddressCountry: 'data-billing-country',
    billingTemplate: 'data-billing-template',
    validationMessageSummary: 'data-valmsg-summary',
    formSpinner: 'data-form-spinner',
    searchAddressSection: 'data-search-address',
    cardDetailsFormContainer: 'data-card-details-form-container',
    cardDetailsAuthenticatedMessage: 'data-card-details-authenticated',
    cardPaymentChange: 'data-card-details-change',
    ajaxUpdate: 'data-ajax-update',
    continuePaymentPlanBtn: "data-payment-continue",
    clearBalanceHeader: 'data-header-clear-account',
    iAndEQuestion: 'data-iande-question',
    iAndEAnswer: 'data-assessment-iande-question',
    iAndEPrompt: 'data-affordability-assessment-iande-prompt',
    affordabilityAssessmentConfirmed: 'data-affordability-assessment-confirm',
    diQuestion: 'data-di-question',
    diAnswer: 'data-assessment-di-question',
    diAmount: 'data-di-amount',
    diAmountValue: 'data-di-amount-value',
    customerNotProvidingData: 'data-cutomomer-not-providing',
    confirmUnableToDetermine: 'data-confirm-unable-to-determine',
    affordabilityAssessmentPrevious: 'data-affordability-assessment-previous',
    paymentAmount: 'data-single-payment-amount',
    accountBalance: 'data-account-balance',
    applePayAccordion: 'data-apple-pay-accordion',
    applePayButton: 'data-apple-pay-button',
    paymentSummaryAmount: 'data-payment-summary-amount',
    googlePayAccordion: 'data-google-pay-accordion'
  },
  classes: {
    disabled: 'disabled'
  },
  constants: {
    paymentProviderPayIt: 10,
    paymentProviderBarclaycard: 2,
    paymentProviderSagepay: 5,
    defaultBillingCountry: 'United Kingdom',
    minimumPaymentAmount: 1
  },
  config: {
    dateFormat: 'DD/MM/YYYY'
  },
  /**
    * Initialise Payment View Listener
    * @public
    * @constructor
    * @param {data} d : PaymentViewModel
    */

  init: function init(d) {
    this.initCart(d);
    this.initSinglePaymentAmountValidation();
    if (d.isAffordabilityAssessmentMandatory) {
      $('[' + this.attr.clearBalanceHeader + ']').hide();
    }
  },
  initSinglePaymentAmountValidation: function initSinglePaymentAmountValidation() {
    var paymentAmountInput = $('[' + this.attr.paymentAmount + ']');
    if (paymentAmountInput.length < 1) {
      return;
    }
    var _this = this;
    if (!$.validator.methods.paymentAmountRequired) {
      $.validator.addMethod('paymentAmountRequired', function (paymentAmountValue, element) {
        if (!paymentAmountValue) {
          return false;
        }
        var paymentAmount = parseFloat(paymentAmountValue.replace(/£/g, '').replace(/,/g, ''));
        return !isNaN(paymentAmount);
      });
    }
    if (!$.validator.methods.minimumPaymentAmount) {
      $.validator.addMethod('minimumPaymentAmount', function (paymentAmountValue, element) {
        var paymentAmount = parseFloat(paymentAmountValue.replace(/£/g, '').replace(/,/g, ''));
        return paymentAmount >= _this.constants.minimumPaymentAmount;
      });
    }
    if (!$.validator.methods.maximumPaymentAmount) {
      $.validator.addMethod('maximumPaymentAmount', function (paymentAmountValue, element) {
        var paymentAmount = parseFloat(paymentAmountValue.replace(/£/g, '').replace(/,/g, ''));
        var accountBalance = parseFloat($('[' + _this.attr.accountBalance + ']').text().replace(/£/g, '').replace(/,/g, ''));
        return paymentAmount <= accountBalance;
      });
    }
    $.validator.unobtrusive.parse('#PaymentAmountForm');
    paymentAmountInput.rules('add', {
      paymentAmountRequired: true,
      minimumPaymentAmount: true,
      maxlength: 20,
      maximumPaymentAmount: true,
      messages: {
        paymentAmountRequired: "Your payment amount cannot be empty",
        minimumPaymentAmount: "A minimum payment of £1.00 is required",
        maxlength: "The payment amount must be less than 20 characters",
        maximumPaymentAmount: "The payment amount cannot exceed the account balance"
      }
    });
  },
  /**
   * Checks for the ApplePaySession object and if the browser/device can use Apple Pay
   * If both are true and apple pay accordion is on the page display the Apple Pay accordion payment option.
   * @private
   */

  initApplePayAccordion: function initApplePayAccordion() {
    var _this = this;
    var applePayAccordion = $('[' + _this.attr.applePayAccordion + ']');
    if (applePayAccordion.length === 0) {
      return;
    }
    if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
      applePayAccordion.show();
      $('[' + _this.attr.applePayButton + ']').on('click', function () {
        _this.onClickApplePayButton();
      });
    }
  },
  /**
   * If Google Pay accordion is on the page and user is eligible to use Google Pay, display the Google Pay accordion payment option.
   * * @private
   */

  initGooglePayAccordion: function initGooglePayAccordion() {
    var _this = this;
    var googlePayAccordion = $('[' + _this.attr.googlePayAccordion + ']');
    var paymentAmount = $('[' + _this.attr.paymentSummaryAmount + ']').text().replace(/£/g, '').replace(/,/g, '');
    var processorCountry = 'GB';
    var currencyCode = 'GBP';
    if (googlePayAccordion.length === 0) {
      return;
    }
    function getGooglePayConfig() {
      $.ajax({
        url: '/google-pay/configuration',
        method: 'GET',
        dataType: 'json',
        success: function success(googlePayConfig) {
          initGooglePay(googlePayConfig);
        },
        error: function error() {
          console.error('Failed to get Google Pay configuration settings');
        }
      });
    }
    function initGooglePay(googlePayConfig) {
      var baseRequest = {
        apiVersion: googlePayConfig.apiVersion,
        apiVersionMinor: googlePayConfig.apiVersionMinor
      };
      var allowedCardNetworks = googlePayConfig.allowedCardNetworks;
      var allowedCardAuthMethods = googlePayConfig.allowedAuthMethods;
      var tokenizationSpecification = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
          'gateway': googlePayConfig.gateway,
          'gatewayMerchantId': googlePayConfig.gatewayMerchantId
        }
      };
      var baseCardPaymentMethod = {
        type: 'CARD',
        parameters: {
          allowedAuthMethods: allowedCardAuthMethods,
          allowedCardNetworks: allowedCardNetworks
        }
      };
      var cardPaymentMethod = Object.assign({}, baseCardPaymentMethod, {
        tokenizationSpecification: tokenizationSpecification
      });
      var paymentsClient = null;
      function getGoogleIsReadyToPayRequest() {
        return Object.assign({}, baseRequest, {
          allowedPaymentMethods: [baseCardPaymentMethod]
        });
      }
      function getGooglePaymentDataRequest() {
        var paymentDataRequest = Object.assign({}, baseRequest);
        paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
        paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
        paymentDataRequest.merchantInfo = {
          merchantId: googlePayConfig.merchantId,
          merchantName: googlePayConfig.merchantName
        };
        return paymentDataRequest;
      }

      // Initialize Google PaymentsClient
      function getGooglePaymentsClient() {
        if (paymentsClient === null) {
          paymentsClient = new google.payments.api.PaymentsClient({
            environment: googlePayConfig.environment
          });
        }
        return paymentsClient;
      }

      // Show Google Pay accordion and add button if user is eligible to use Google Pay
      function initGooglePayButton() {
        var paymentsClient = getGooglePaymentsClient();
        paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest()).then(function (response) {
          if (response.result) {
            var paymentDataRequest = getGooglePaymentDataRequest();
            googlePayAccordion.show();

            // Add the Google Pay button to the page
            var button = paymentsClient.createButton({
              onClick: function onClick() {
                _this.onClickGooglePayButton(paymentsClient, paymentDataRequest);
              },
              buttonType: 'pay',
              buttonColor: 'black',
              buttonSizeMode: 'fill',
              buttonRadius: 25
            });
            document.getElementById('GooglePayButtonContainer').appendChild(button);

            //  Prefetch payment data to improve performance
            prefetchGooglePaymentData(paymentsClient);
          }
        })["catch"](function (err) {
          console.error(err);
        });
      }

      // Provide Google Pay API with a payment amount, currency, and amount status
      function getGoogleTransactionInfo() {
        return {
          countryCode: processorCountry,
          currencyCode: currencyCode,
          totalPriceStatus: 'FINAL',
          totalPrice: paymentAmount
        };
      }
      function prefetchGooglePaymentData(paymentsClient) {
        var paymentDataRequest = getGooglePaymentDataRequest();
        // transactionInfo must be set but does not affect cache
        paymentDataRequest.transactionInfo = {
          totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
          currencyCode: currencyCode
        };
        paymentsClient.prefetchPaymentData(paymentDataRequest);
      }
      initGooglePayButton();
    }
    getGooglePayConfig();
  },
  /**
   * Initialise Payment Cart Object
   * @private
   * @param {data} d : PaymentViewModel
   */

  initCart: function initCart(d) {
    this.cart.paymentPlanType = parseInt(d.paymentPlanType);
    this.cart.accountReference = parseInt(d.accountReference);
    this.cart.accountBalance = d.accountBalance;
    this.cart.clearBalance = d.clearBalance;
    switch (d.paymentPlanType) {
      case 2:
        if (d.isPlanExplorerSource === false) this.cart.clearBalance = true;
      case 4:
        if (d.isPlanExplorerSource === false) this.cart.clearBalance = true;
    }
    return this.cart;
  },
  /**
   * Initialise Card Expiry Dates
   * @private
   * @param {element} container : Payment Step Container
   */

  initCardExpiryDates: function initCardExpiryDates(container) {
    var _this = this;
    var month = $(container).find('[data-billing-expirymonth]');
    var year = $(container).find('[data-billing-expiryyear]');
    if ($(container).find(month).length > 0 && $(container).find(year).length > 0) {
      var date = new Date();
      var months = app.helpers.getMonths('MM');
      var currentMonth = moment(date).format('MM');
      var currentYear = moment(date).format('YYYY');
      var minYear = parseInt(currentYear);
      var maxYear = minYear + 10; /* Set card maximum expiry year limit here. */

      if (this.cart.billingCardExpiryMonth === undefined) {
        month.append('<option value="0" selected="selected">MM</option>');
      }
      if (this.cart.billingCardExpiryYear === undefined) {
        year.append('<option value="0" selected="selected">YYYY</option>');
      }
      var options = $.extend(app.options.select(), {
        minimumResultsForSearch: Infinity
      });
      $.each(months, function (i, m) {
        if (m === _this.cart.billingCardExpiryMonth) {
          month.append('<option value="' + m + '" selected="selected">' + m + '</option>');
        } else {
          month.append('<option value="' + m + '">' + m + '</option>');
        }
      });
      for (var y = minYear; y < maxYear; y++) {
        if (y.toString() === _this.cart.billingCardExpiryYear) {
          year.append('<option value="' + y.toString() + '" selected="selected">' + y.toString() + '</option>');
        } else {
          year.append('<option value="' + y.toString() + '">' + y.toString() + '</option>');
        }
      }
      month.select2(options);
      year.select2(options);
    }
  },
  /**
   * Initialise Start Date Picker
   * @private
   * @param {element} container : Payment Step Container
   */
  initStartDatePicker: function initStartDatePicker(container) {
    var datepicker = $(container).find('[data-payment-startdate]');
    var maxDays = 0;
    var minDays = 0;
    var paymentMethod = $(container).find('[data-payment-method]');
    if (paymentMethod.length) {
      var method;
      $(paymentMethod).each(function () {
        if ($(this).is(':checked')) {
          method = $(this).val();
        }
      });
      if (method == 'RecurrentPaymentByBankAccount') {
        minDays = 14;
      } else {
        minDays = 0;
      }
      maxDays = 60;
    }
    if (datepicker.length > 0) {
      var minDate = app.helpers.getDateFromDays(minDays);
      var maxDate = app.helpers.getDateFromDays(maxDays);
      if (datepicker.val()) {
        var currentSetDate = moment(datepicker.val(), this.config.dateFormat);
        var date = currentSetDate.toDate();
        var startDateString = minDate.toString(this.config.dateFormat);
        if (date >= minDate) startDateString = datepicker.val();
      }
      var options = $.extend(app.options.datepicker(), {
        min: minDate,
        max: maxDate,
        onOpen: function onOpen() {
          setTimeout(function () {
            datepicker.pickadate('set').set('select', datepicker.val(), {
              format: 'dd-mm-yyyy'
            });
          }, 1);
        },
        onClose: function onClose() {
          $('.select2-container--open').remove();
        }
      });
      datepicker.pickadate(options);
      datepicker.pickadate('picker').set('min', app.helpers.getDateFromDays(minDays));
      datepicker.val(startDateString);
    }
  },
  /**
  * Init Search Button for Search Postcode
  * Checks to see there is a postcode and if it is being pasted in by the mouse
  * @private
  */

  initPostcodeSearchListener: function initPostcodeSearchListener() {
    var _this = this;
    if ($('[' + this.attr.postcodeSearchBox + ']')) {
      $('[' + this.attr.postcodeSearchBox + ']').bind('paste', function () {
        $('[' + _this.attr.postcodeSearchBtn + ']').removeClass(_this.classes.disabled);
        $('[' + _this.attr.postcodeSearchBtn + ']').prop('disabled', false);
        $('[' + _this.attr.postcodeValidationsErrors + ']').hide();
      });
    }
  },
  initCardDetailsListeners: function initCardDetailsListeners() {
    var _this = this;
    if ($('[' + this.attr.cardDetailsFormContainer + ']').length) {
      $('[' + this.attr.formSpinner + ']').show();
      var checkForCardForm = setInterval(function () {
        if ($('#payment-iframe').length) {
          clearInterval(checkForCardForm);
          $('[' + _this.attr.formSpinner + ']').hide();
        }
      }, 500);
      var hasCardDetailsId = $('[' + this.attr.cardDetailsAuthenticatedMessage + ']').attr(this.attr.cardDetailsAuthenticatedMessage);
      if (hasCardDetailsId === 'True') {
        $('[' + this.attr.cardDetailsFormContainer + ']').hide();
        $('[' + this.attr.cardDetailsAuthenticatedMessage + ']').show();
        $('[' + this.attr.continuePaymentPlanBtn + ']').show();
      }
    }
  },
  initCardFormProcessing: function initCardFormProcessing(responseCardIdentifier) {
    var _this = this;
    $('[' + _this.attr.formSpinner + ']').show();
    var merchantSessionToken = $('#NewMerchantSessionKey').val();
    var merchantSessionExpiryDate = $('#NewMerchantSessionExpiryDate').val();
    var browserLanguage = navigator.language;
    var browserColorDepth = screen.colorDepth;
    var browserScreenHeight = screen.height;
    var browserScreenWidth = screen.width;
    var browserTimeZoneOffset = new Date().getTimezoneOffset();
    var browserJavaEnabled = navigator.javaEnabled();
    $('#MerchantSessionKey').val(merchantSessionToken);
    $('#MerchantSessionExpiryDate').val(merchantSessionExpiryDate);
    $('#CardIdentifier').val(responseCardIdentifier);
    $('#BrowserLanguage').val(browserLanguage);
    $('#BrowserColorDepth').val(browserColorDepth);
    $('#BrowserScreenHeight').val(browserScreenHeight);
    $('#BrowserScreenWidth').val(browserScreenWidth);
    $('#BrowserTimeZoneOffset').val(browserTimeZoneOffset);
    $('#BrowserJavaEnabled').val(browserJavaEnabled);
    var offset;
    if ($(window).width() < 768) {
      offset = 115;
    } else if ($(window).width() >= 768 && $(window).width() < 992) {
      offset = 140;
    } else {
      offset = 170;
    }
    var form = document.getElementById('PaymentCardForm');
    var isSummaryStep = false;
    if (!form) {
      form = document.getElementById('SecurePaymentCardDetailsForm');
    }
    if (!form) {
      form = document.getElementById('PaymentSummaryForm');
      isSummaryStep = form && form.length ? true : false;
    }
    if (!form) {
      form = document.getElementById('CustomerOfferSummaryForm');
      isSummaryStep = form && form.length ? true : false;
    }
    var progression = isSummaryStep ? '&progression=complete&paymentProvider=' + _this.constants.paymentProviderSagepay : '&progression=next';
    var elToUpdateId = $('[' + _this.attr.ajaxUpdate + ']').attr(_this.attr.ajaxUpdate);
    $.ajax({
      url: form.action,
      method: 'POST',
      data: $(form).serialize() + progression,
      success: function success(response) {
        if (isSummaryStep) {
          if (response !== null && response.hasErrors) {
            var vs = $('[' + _this.attr.validationMessageSummary + ']');
            $(vs).children('ul').empty();
            $.each(response.errors, function (i, item) {
              vs.children('ul').append($('<li></li>').text(item));
            });
            $(vs).addClass('validation-summary-errors');
            $('[' + _this.attr.formSpinner + ']').hide();
            $('html, body').animate({
              scrollTop: $('body').offset().top + offset
            }, 500);
          } else {
            window.location = response.redirectUrl;
          }
        } else {
          $(elToUpdateId).html(response);
          _this.onChangePaymentStep(elToUpdateId);
        }
      },
      error: function error(response) {
        $('[' + _this.attr.formSpinner + ']').hide();
        console.log(response);
      }
    });
  },
  onChangeSinglePaymentAmount: function onChangeSinglePaymentAmount() {
    var isPaymentAmountValid = $('#PaymentAmountForm').valid();
    if (isPaymentAmountValid) {
      $('[' + this.attr.validationMessageSummary + ']').hide();
    } else {
      $('[' + this.attr.validationMessageSummary + ']').show();
    }
  },
  onChangePaymentCard: function onChangePaymentCard() {
    $('[' + this.attr.cardDetailsFormContainer + ']').show();
    $('#sp-container').css('height', '163px');
    $('#payment-iframe').css('height', '163px');
    $('[' + this.attr.cardDetailsAuthenticatedMessage + ']').hide();
    $('[' + this.attr.continuePaymentPlanBtn + ']').hide();
    $('[' + this.attr.cardPaymentChange + ']').hide();
  },
  /**
   * Payment Step Change
   * Listens for a payment step change.
   * @private
   * @param {element} id : Payment Step Container
   */

  onChangePaymentStep: function onChangePaymentStep(id) {
    var offset;
    if ($(window).width() < 768) {
      offset = 115;
    } else if ($(window).width() >= 768 && $(window).width() < 992) {
      offset = 140;
    } else {
      offset = 170;
    }
    $('html, body').animate({
      scrollTop: $('body').offset().top + offset
    }, 500);
    app.initElementListeners($(id));
    this.initCardExpiryDates(id);
    this.initStartDatePicker(id);
    this.initKeyPressEvents();
    this.initDisplaySourceOfFundsWarning();
    this.initDisplayBillWarning();
    this.initPostcodeSearchListener();
    this.initCardDetailsListeners(id);
    this.initSinglePaymentAmountValidation();
    this.initApplePayAccordion();
    this.initGooglePayAccordion();
    $('[' + this.attr.clearBalanceHeader + ']').show();
  },
  initKeyPressEvents: function initKeyPressEvents() {
    var form = document.forms[0];
    if (form == null) return;
    $(form).keydown(function (event) {
      if (event.keyCode == 13 || event.key === 'Enter') {
        return false;
      }
    });
  },
  /**
   * On Change Payment Agreement
   * @private
   * @param {event} e : Action event
   */

  onChangePaymentAgreement: function onChangePaymentAgreement(e) {
    var agreementChecked = $(e.currentTarget).is(':checked');
    if (agreementChecked) {
      $('.payment-step-actions').find('[data-cpa-agreed]').removeClass('disabled');
      $('.payment-step-actions').find('[data-cpa-agreed]').removeAttr('disabled');
    } else {
      $('.payment-step-actions').find('[data-cpa-agreed]').addClass('disabled');
      $('.payment-step-actions').find('[data-cpa-agreed]').attr('disabled', true);
    }
  },
  /**
   * Payment Frequency Change
   * Listening for change event on the payment frequency options
   * @private
   * @param {event} e : Action event
   */

  onChangePaymentFrequency: function onChangePaymentFrequency(e) {
    var elm = $(e.currentTarget).parents('.form-element');
    var desc = elm.find('.form-element__desc strong');
    switch (e.currentTarget.value) {
      case 'Weekly':
        desc.html('process on the same day every week');
        break;
      case 'Fortnightly':
        desc.html('process on the same day every two weeks');
        break;
      case 'FourWeeks':
        desc.html('process on the same day every four weeks');
        break;
      case 'Monthly':
        desc.html('process on the same day every month');
        break;
      default:
        console.error('Unknown payment frequency selected');
        break;
    }
  },
  /**
   * Payment Pay In Full Toggle
   * Listening for change event on toggle switch
   * @private
   * @param {event} e : Action event
   */

  onChangePaymentPayInFull: function onChangePaymentPayInFull(e) {
    var label = $('[data-clearbalance-label]');
    var desc = $('[data-clearbalance-desc]');
    var navigatorButtons = $('.payment-navigator :button');
    if (navigatorButtons.length > 0) {
      navigatorButtons.removeClass("valid");
      navigatorButtons.removeClass("invalid");
      navigatorButtons.attr("disabled", "disabled");
    }
    if ($(e.currentTarget).prop('checked')) {
      label.html('YES');
      desc.html('Yes, the value of the plan will <strong>CLEAR</strong> the balance.');
      this.cart.clearBalance = true;
    } else {
      label.html('NO');
      desc.html('No, the value of the plan will <strong>NOT CLEAR</strong> the balance.');
      this.cart.clearBalance = false;
    }
  },
  /**
   * Payment Expiry Date Change
   * Listening for change event on payment card expiry date
   * @private
   * @param {event} e : Action event
   */

  onChangePaymentExpiryDate: function onChangePaymentExpiryDate(e) {
    if (e.currentTarget.name === 'CardExpiryMonth') {
      this.cart.billingCardExpiryMonth = e.currentTarget.value;
    } else if (e.currentTarget.name === 'CardExpiryYear') {
      this.cart.billingCardExpiryYear = e.currentTarget.value;
    }
  },
  /**
   * Source Of Funds Warning
   * Listening for change to specific value and show warning
   * @private
   * @param {event} e : Action event
   */

  onChangeSourceOfFunds: function onChangeSourceOfFunds(e) {
    this._setSofWarningState();
  },
  /**
   * Will display the Display Bill Warning message
   * Listens for a change of the affordability questions.
   * Makes the bills warning visible if any required question is answered no
   * @public
   */
  onChangeAffordabilityQuestion: function onChangeAffordabilityQuestion(e) {
    $(e.currentTarget).find('input').removeClass('input-validation-error');
    this._setBillWarningDisplay();
    isCustomerOfferAffordability = $('[data-rejection-option]').length > 0;
    if (isCustomerOfferAffordability) {
      var requiredQuestionAnswersNo = this._checkRequiredQuestionsAnsweredNo();
      if (requiredQuestionAnswersNo) {
        $('[data-payment-confirm]').val('Unaffordable');
        $('[data-payment-confirm]').attr('data-customer-offer-reject', '');
        $('[data-payment-confirm]').text('Confirm Unaffordable');
        $('[data-payment-confirm]').addClass('btn--danger');
      } else {
        $('[data-payment-confirm]').val('next');
        $('[data-payment-confirm]').removeAttr('data-customer-offer-reject');
        $('[data-payment-confirm]').text('Confirm Affordability');
        $('[data-payment-confirm]').removeClass('btn--danger');
      }
    }
  },
  /**
  * Display bill message warning if question answer is no.
  * @private
  */

  _setBillWarningDisplay: function _setBillWarningDisplay() {
    var requiredQuestionAnswersNo = this._checkRequiredQuestionsAnsweredNo();
    if (requiredQuestionAnswersNo) {
      $('[' + this.attr.billWarning + ']').show();
      $('[' + this.attr.validationMessageSummary + ']').hide();
    } else {
      $('[' + this.attr.billWarning + ']').hide();
    }
  },
  /**
  * Persiste bill message warning
  * Listens for a change of the affordability questions.
  * Makes the questions optional affordability question display if any required question is answered no
  * @public
  */

  initDisplayBillWarning: function initDisplayBillWarning() {
    this._setBillWarningDisplay();
  },
  /**
   * Persist Source Of Funds Warning
   * Shows the Source of Funds Warning when moving back to the Affordability page
   * @private
   */

  initDisplaySourceOfFundsWarning: function initDisplaySourceOfFundsWarning() {
    this._setSofWarningState();
  },
  /**
  * Payment Plan Begin Request
  * Handles the process for both complete and previous buttons on the payment summary step
  * @private
  * @param {event} e : Action event
  * @param {data} progression : The state which decides how to proceed
  */

  onPaymentSummaryRequestBegin: function onPaymentSummaryRequestBegin(e, progression, paymentProviderName) {
    e.preventDefault();
    var paymentProvider;
    if (paymentProviderName == 'PayIt') {
      paymentProvider = this.constants.paymentProviderPayIt;
    } else if (paymentProviderName == 'Barclaycard') {
      paymentProvider = this.constants.paymentProviderBarclaycard;
    }
    switch (progression) {
      case 'complete':
        this.onPaymentSummaryRequestComplete(paymentProvider);
        break;
      case 'previous':
        this.onPaymentSummaryRequestPrevious();
        break;
      default:
        break;
    }
  },
  /**
   * Payment Plan Previous
   * Manages the process when the 'previous' button is clicked
   * @private
   */

  onPaymentSummaryRequestPrevious: function onPaymentSummaryRequestPrevious() {
    $('[' + this.attr.formSpinner + ']').show();
    var that = this;
    var form = document.getElementById('PaymentSummaryForm');
    if (!form) {
      form = document.getElementById('CustomerOfferSummaryForm');
    }
    if (form === null || form === undefined) {
      console.log('No form found on page - unable to proceed to previous step');
      return;
    }
    var elToUpdateId = $(document.forms[0]).attr('data-ajax-update');
    if (elToUpdateId === null || elToUpdateId === undefined) {
      console.log('No element found to update - unable to proceed to previous step');
    }
    $.ajax({
      url: form.action,
      method: 'POST',
      data: $(form).serialize() + '&progression=previous',
      success: function success(response) {
        $(elToUpdateId).html(response);
        that.onChangePaymentStep(elToUpdateId);
      }
    });
  },
  /**
   * Payment Step Next
   * Manages the process when the 'Confirm' button is clicked
   * @private
   */

  onPaymentSummaryRequestNext: function onPaymentSummaryRequestNext() {
    var form = document.forms[0];
    var elToUpdateId = $(document.forms[0]).attr('data-ajax-update');
    $('[' + this.attr.formSpinner + ']').show();
    //submits a copy of the form in background to store current state for page reload or redirect while signing in to enhanced login
    $.ajax({
      url: form.action,
      method: 'POST',
      data: $(form).serialize() + '&progression=next',
      success: function success(response) {
        $(elToUpdateId).html(response);
        app.viewListeners.onChangePaymentStep(elToUpdateId);
      }
    });
    $.magnificPopup.close();
  },
  /**
  * Payment Plan Complete
  * Manages the process when the 'confirm' button is clicked
  * @private
  */

  onPaymentSummaryRequestComplete: function onPaymentSummaryRequestComplete(paymentProvider) {
    $('[data-payment-spinner]').show();
    _this = this;
    var form = document.getElementById('PaymentSummaryForm');
    if (!form) {
      form = document.getElementById('CustomerOfferSummaryForm');
    }

    // If this is ever true then we have a big problem
    if (form === null || form === undefined) {
      console.log('No form found on page - unable to proceed to complete payment');
      return;
    }
    $.ajax({
      url: form.action,
      method: 'POST',
      data: $(form).serialize() + '&progression=complete' + '&paymentProvider=' + paymentProvider,
      success: function success(data) {
        if (data === null) {
          console.error('Unable to complete payment process - the response is null');
          data = {
            hasErrors: true,
            errors: []
          };
          data.errors.push('There was an error processing your payment. Please try again later.');
        }
        if (data !== null && data.hasErrors) {
          // Write errors to UI
          var vs = $('[' + _this.attr.validationMessageSummary + ']');
          $(vs).children('ul').empty();
          $.each(data.errors, function (i, item) {
            vs.children('ul').append($('<li></li>').text(item));
          });
          $(vs).addClass('validation-summary-errors');
          $('[data-payment-spinner]').hide();
        }
        if (data !== null && data.redirectUrl !== null && data.redirectUrl !== undefined && data.redirectUrl !== '') {
          console.log(data.redirectUrl);
          window.location = data.redirectUrl;
        }
      }
    });
  },
  /**
   * Search Addresses By Postcode
   * Create a list of addresses based on postcode entered
   * @public
   */

  onSearchAddressesByPostcode: function onSearchAddressesByPostcode(e) {
    e.preventDefault();
    var _this = this;
    $('[' + this.attr.postcodeSearchBtn + ']').addClass(this.classes.disabled);
    $('[' + this.attr.postcodeSearchBtn + ']').prop('disabled', true);
    $('[' + this.attr.noAddressOptions + ']').hide();
    $('[' + this.attr.billingDisplayAddress + ']').hide();
    $('[' + this.attr.validationMessageSummary + ']').hide();
    $('[' + this.attr.manualAddressEntry + ']').hide();
    this._resetManualAddressEntryForm();
    $('[' + this.attr.manualAddressToggle + ']').val(false);
    var postcode = $('[' + this.attr.postcodeSearchBox + ']').val();
    var elToUpdate = $('[' + this.attr.addressSelectList + ']');
    var options = $.extend(app.options.select(), {
      minimumResultsForSearch: Infinity
    });
    var postcodeVaild = this._postcodeValidation(postcode);
    if (!postcodeVaild) {
      return;
    }
    $('[' + this.attr.formSpinner + ']').show();
    $.ajax({
      url: '/postcode-lookup?postcode=' + postcode,
      method: 'GET',
      success: function success(response) {
        elToUpdate.select2().empty();
        if (response) {
          elToUpdate.append("<option data-temp-address-option>Please select address</option>");
          for (var x in response) {
            elToUpdate.append("<option data-address-option value='" + JSON.stringify(response[x]) + "'>" + response[x].fullAddress + "</option>");
          }
          elToUpdate.select2(options);
          $('[' + _this.attr.noAddressOptions + ']').hide();
          $('[' + _this.attr.addressOptionsList + ']').show();
        } else {
          $('[' + _this.attr.addressOptionsList + ']').hide();
          $('[' + _this.attr.noAddressOptions + ']').show();
        }
        $('[' + _this.attr.formSpinner + ']').hide();
      },
      error: function error(response) {
        $('[' + _this.attr.formSpinner + ']').hide();
        console.log(response);
      }
    });
    this._disableConfirmation();
  },
  /**
  * Toggle to Manually Add Address
  * Toggles manual address visible or hides if visible
  * @public
  */
  onToggleManuallyAddAddress: function onToggleManuallyAddAddress(e) {
    e.preventDefault();
    if ($('[' + this.attr.manualAddressEntry + ']').is(':visible')) {
      $('[' + this.attr.manualAddressEntry + ']').hide();
      $('[' + this.attr.manualAddressToggle + ']').val(false);
      $('[' + this.attr.postcodeSearchBtn + ']').addClass(this.classes.disabled);
      $('[' + this.attr.postcodeSearchBtn + ']').prop('disabled', true);
      this._disableConfirmation();
    } else {
      $('[' + this.attr.manualAddressEntry + ']').show();
      $('[' + this.attr.billingDisplayAddress + ']').hide();
      $('[' + this.attr.noAddressOptions + ']').hide();
      $('[' + this.attr.addressOptionsList + ']').hide();
      $('[' + this.attr.manualAddressToggle + ']').val(true);
      $('[' + this.attr.postcodeSearchBox + ']').val('');
      $('[' + this.attr.postcodeValidationsErrors + ']').hide();
      this._enableConfirmation();
      this._resetManualAddressEntryForm();
    }
  },
  /**
  * On Address Selection
  * On selecting an address brought back from dropdown populate form
  * @public
  */
  onAddressSelection: function onAddressSelection(e) {
    $('[' + this.attr.addressOptionsList + ']').find('[data-temp-address-option]').remove();
    var addressJson = $(e.currentTarget).val();
    var addressModel = JSON.parse(addressJson);
    if (addressModel.street) {
      if (addressModel.property === this.attr.billingDisplayAddress) {
        $('[' + this.attr.billingAddressLine1 + ']').val(addressModel.property);
        $('[' + this.attr.billingAddressLine2 + ']').val(addressModel.street);
        $('[' + this.attr.billingAddressLine3 + ']').val(addressModel.locality);
        $('[' + this.attr.billingAddressLine1 + '-display]').html(addressModel.property);
        $('[' + this.attr.billingAddressLine2 + '-display]').html(addressModel.street);
        $('[' + this.attr.billingAddressLine3 + '-display]').html(addressModel.locality);
      } else if (addressModel.property) {
        $('[' + this.attr.billingAddressLine1 + ']').val(addressModel.property + ', ' + addressModel.street);
        $('[' + this.attr.billingAddressLine2 + ']').val(addressModel.locality);
        $('[' + this.attr.billingAddressLine1 + '-display]').html(addressModel.property + ', ' + addressModel.street);
        $('[' + this.attr.billingAddressLine2 + '-display]').html(addressModel.locality);
      } else {
        $('[' + this.attr.billingAddressLine1 + ']').val(addressModel.street);
        $('[' + this.attr.billingAddressLine2 + ']').val(addressModel.locality);
        $('[' + this.attr.billingAddressLine1 + '-display]').html(addressModel.street);
        $('[' + this.attr.billingAddressLine2 + '-display]').html(addressModel.locality);
      }
      $('[' + this.attr.billingAddressCity + ']').val(addressModel.town);
      $('[' + this.attr.billingAddressPostcode + ']').val(addressModel.postcode);
      $('[' + this.attr.billingAddressCountry + ']').val(addressModel.subCountryName);
      $('[' + this.attr.billingAddressCity + '-display]').html(addressModel.town);
      $('[' + this.attr.billingAddressPostcode + '-display]').html(addressModel.postcode);
      $('[' + this.attr.billingAddressCountry + '-display]').html(addressModel.subCountryName);
      $('[' + this.attr.billingDisplayAddress + '').show();
      this._enableConfirmation();
    }
  },
  /**
  * Toggle to Change Billing Address
  * Toggle to allow for the postcode lookup or manual address entry
  * @public
  */
  onToggleChangeBillingAddress: function onToggleChangeBillingAddress(e) {
    e.preventDefault();
    var _this = this;
    var template = $('[' + this.attr.billingTemplate + ']');
    var showCustomerAddress = $('[' + this.attr.searchAddressSection + ']').is(':visible');
    $('[' + this.attr.formSpinner + ']').show();
    $('[' + this.attr.validationMessageSummary + ']').hide();
    if (showCustomerAddress) {
      $.ajax({
        url: '/customer-billing-address',
        method: 'GET',
        success: function success(response) {
          $(template).html(response);
          $('[' + _this.attr.formSpinner + ']').hide();
        },
        error: function error(response) {
          $('[' + _this.attr.formSpinner + ']').hide();
          console.log(response);
        }
      });
      this._enableConfirmation();
      $('[' + this.attr.notCustomerAddressToggle + ']').val(false);
    } else {
      $.ajax({
        url: '/payment-billing-address',
        method: 'GET',
        success: function success(response) {
          $(template).html(response);
          $('[' + _this.attr.formSpinner + ']').hide();
          $('[' + _this.attr.billingAddressCountry + ']').select2();
          _this.initPostcodeSearchListener();
        },
        error: function error(response) {
          $('[' + _this.attr.formSpinner + ']').hide();
          console.log(response);
        }
      });
      this._disableConfirmation();
      $('[' + this.attr.notCustomerAddressToggle + ']').val(true);
    }
  },
  /**
  * On Change Search Postcode
  * Enables to search button after the postcode has been changed.
  * @public
  */
  onSearchPostcodeChange: function onSearchPostcodeChange() {
    $('[' + this.attr.postcodeSearchBtn + ']').removeClass(this.classes.disabled);
    $('[' + this.attr.postcodeSearchBtn + ']').prop('disabled', false);
    $('[' + this.attr.postcodeValidationsErrors + ']').hide();
  },
  onOPayoSinglePayment: function onOPayoSinglePayment(e) {
    e.preventDefault();
    app.helpers.openModal("/payment/common/payment-card", 'ajax');
  },
  onClickApplePayButton: function onClickApplePayButton() {
    var _this = this;
    var sessionValidationToken = null;
    var validationMessageSummary = $('[' + _this.attr.validationMessageSummary + ']');
    validationMessageSummary.children('ul').empty();
    function showValidationErrorMessage(message) {
      var validationMessageSummary = $('[' + _this.attr.validationMessageSummary + ']');
      validationMessageSummary.children('ul').empty();
      validationMessageSummary.addClass('validation-summary-errors');
      validationMessageSummary.children('ul').append($('<li></li>').text(message));
      $('html, body').animate({
        scrollTop: $('body').offset().top
      }, 500);
      $('[data-payment-spinner]').hide();
    }
    function generateSession() {
      var session = new ApplePaySession(6, getPaymentRequest());
      var userClosedPaymentSheet = false;

      // fires when the user dismisses the Apple Pay sheet
      session.oncancel = function () {
        userClosedPaymentSheet = true;
        $('[data-payment-spinner]').hide();
      };

      // this executes after the session is created and Apple validates the merchant
      session.onvalidatemerchant = function () {
        getApplePaySession(function (response) {
          sessionValidationToken = response.sessionValidationToken;
          session.completeMerchantValidation(response);
        }, function () {
          session.abort();
          if (userClosedPaymentSheet) {
            return;
          }
          console.error('Apple Pay session request failed');
          showValidationErrorMessage("There was an error for Apple Pay. Please use another payment method.");
        });
      };

      // this executes when the user authorises the payment on their device
      session.onpaymentauthorized = function (event) {
        performTransaction(event.payment, function (response) {
          var hasRedirectUrl = !!(response !== null && response !== void 0 && response.redirectUrl);
          var isPaymentSuccessful = (response === null || response === void 0 ? void 0 : response.hasErrors) === false;
          var errors = response && response.errors ? response.errors : '';
          session.completePayment(isPaymentSuccessful ? ApplePaySession.STATUS_SUCCESS : ApplePaySession.STATUS_FAILURE);
          if (!isPaymentSuccessful) {
            console.error('Apple Pay payment failed', errors);
            showValidationErrorMessage("There was an error processing your payment. Please use another payment method.");
            return;
          }
          if (hasRedirectUrl) {
            window.location.href = response.redirectUrl;
          } else {
            window.location.href = '/accounts';
          }
        }, function (message) {
          session.completePayment(ApplePaySession.STATUS_FAILURE);
          console.error('Apple Pay payment request failed', message || '');
          showValidationErrorMessage("There was an error processing your payment. Please use another payment method.");
        });
      };
      session.begin();
    }
    function getPaymentRequest() {
      var paymentAmount = $('[' + _this.attr.paymentSummaryAmount + ']').text().replace(/£/g, '').replace(/,/g, '');
      return {
        countryCode: 'GB',
        currencyCode: 'GBP',
        total: {
          label: 'Total',
          type: 'final',
          amount: paymentAmount
        },
        supportedNetworks: ['masterCard', 'visa', 'discover', 'maestro'],
        merchantCapabilities: ['supports3DS', 'supportsDebit'],
        requiredBillingContactFields: ['postalAddress', 'name']
      };
    }
    function performTransaction(payment, onSuccessHandler, onErrorHandler) {
      var jsonPayloadString = JSON.stringify(payment);
      var base64EncodedPayload = btoa(jsonPayloadString);
      var formEl = document.getElementById('PaymentSummaryForm');
      if (!formEl) {
        if (onErrorHandler) {
          onErrorHandler('PaymentSummaryForm not found');
        }
        return;
      }
      if (!sessionValidationToken) {
        if (onErrorHandler) {
          onErrorHandler('sessionValidationToken not available');
        }
        return;
      }
      var formData = new FormData(formEl);
      formData.set('NotificationData', base64EncodedPayload);
      formData.set('SessionTokenValue', sessionValidationToken);
      $.ajax({
        url: '/payment/single-payment/apple-pay/summary',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: onSuccessHandler,
        error: onErrorHandler
      });
    }
    function getApplePaySession(onSuccessHandler, onErrorHandler) {
      $.ajax({
        url: '/apple-pay/session-key',
        method: 'GET',
        success: onSuccessHandler,
        error: onErrorHandler
      });
    }
    $('[data-payment-spinner]').show();
    generateSession();
  },
  onClickGooglePayButton: function onClickGooglePayButton(paymentsClient, paymentDataRequest) {
    var _this = this;
    var validationMessageSummary = $('[' + _this.attr.validationMessageSummary + ']');
    validationMessageSummary.children('ul').empty();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'PaymentProcessComplete'
    });
    function showValidationErrorMessage(message) {
      var validationMessageSummary = $('[' + _this.attr.validationMessageSummary + ']');
      validationMessageSummary.children('ul').empty();
      validationMessageSummary.addClass('validation-summary-errors');
      validationMessageSummary.children('ul').append($('<li></li>').text(message));
      $('html, body').animate({
        scrollTop: $('body').offset().top
      }, 500);
      $('[data-payment-spinner]').hide();
    }

    // Show Google Pay payment sheet
    function showGooglePaySheet(paymentsClient, paymentDataRequest) {
      paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
        processPayment(paymentData);
      })["catch"](function (err) {
        if (err.statusCode === 'CANCELED') {
          return;
        }
        console.error(err);
        showValidationErrorMessage("There was an error for Google Pay. Please use another payment method.");
      });
    }
    function processPayment(paymentData) {
      $('[data-payment-spinner]').show();
      var googlePayToken = paymentData.paymentMethodData.tokenizationData.token;
      document.getElementById('BrowserLanguage').value = navigator.language || navigator.userLanguage;
      document.getElementById('BrowserColorDepth').value = screen.colorDepth;
      document.getElementById('BrowserScreenHeight').value = screen.height;
      document.getElementById('BrowserScreenWidth').value = screen.width;
      document.getElementById('BrowserTimeZoneOffset').value = new Date().getTimezoneOffset();
      document.getElementById('BrowserJavaEnabled').value = navigator.javaEnabled();
      document.getElementById('BrowserJavascriptEnabled').value = 'true';
      var formEl = document.getElementById('PaymentSummaryForm');
      var formData = new FormData(formEl);
      formData.set('PaymentToken', googlePayToken);
      $.ajax({
        url: '/payment/single-payment/google-pay/summary',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function success(response) {
          var hasRedirectUrl = !!(response !== null && response !== void 0 && response.redirectUrl);
          var isPaymentSuccessful = (response === null || response === void 0 ? void 0 : response.hasErrors) === false;
          var errors = response && response.errors ? response.errors : '';
          if (!isPaymentSuccessful) {
            console.error('Google Pay payment failed', errors);
            showValidationErrorMessage("There was an error processing your payment. Please use another payment method.");
            return;
          }
          if (hasRedirectUrl) {
            window.location.href = response.redirectUrl;
          } else {
            window.location.href = '/accounts';
          }
        },
        error: function error() {
          console.error('Google Pay payment failed');
          showValidationErrorMessage("There was an error processing your payment. Please use another payment method.");
        }
      });
    }
    showGooglePaySheet(paymentsClient, paymentDataRequest);
  },
  /**
  * Reset Address Entry From
  * Enties fields populated on the address entry form
  * @private
  */
  _resetManualAddressEntryForm: function _resetManualAddressEntryForm() {
    $('[' + this.attr.billingAddressLine1 + ']').val('');
    $('[' + this.attr.billingAddressLine2 + ']').val('');
    $('[' + this.attr.billingAddressLine3 + ']').val('');
    $('[' + this.attr.billingAddressCity + ']').val('');
    $('[' + this.attr.billingAddressPostcode + ']').val('');
    $('[' + this.attr.billingAddressCountry + ']').val(this.constants.defaultBillingCountry);
  },
  /**
  * Validates Search postcode
  * Checks that lookup postcode has a value and does not contain any none alpha numeric characters
  * @private
  */
  _postcodeValidation: function _postcodeValidation(postcode) {
    if (!postcode) {
      $('[' + this.attr.noAddressOptions + ']').show();
      $('[' + this.attr.addressOptionsList + ']').hide();
      return false;
    }
    var alphaNumbericRegex = /^[\w\-\s]+$/;
    var postcodeVaild = alphaNumbericRegex.test(postcode);
    if (!postcodeVaild) {
      $('[' + this.attr.postcodeValidationsErrors + ']').show();
      $('[' + this.attr.noAddressOptions + ']').hide();
      $('[' + this.attr.addressOptionsList + ']').hide();
      return false;
    }
    $('[' + this.attr.noAddressOptions + ']').hide();
    $('[' + this.attr.postcodeValidationsErrors + ']').hide();
    return true;
  },
  /**
   * Enable Step Confirmation Button
   * @private
   */

  _enableConfirmation: function _enableConfirmation() {
    var btn = $('[data-payment-confirm]');
    if (btn.length) {
      btn.removeClass('disabled');
      btn.prop('disabled', false);
    }
  },
  /**
   * Disable Step Confirmation Button
   * @private
   */

  _disableConfirmation: function _disableConfirmation() {
    var btn = $('[data-payment-confirm]');
    if (btn.length) {
      btn.addClass('disabled');
      btn.prop('disabled', true);
    }
  },
  /**
  * Shows/hides the SOF warning message
  * @private
  */
  _setSofWarningState: function _setSofWarningState() {
    var sofWarning = $('[data-source-of-funds-warning]');
    var selectOption = $('[data-source-of-funds]').select2('data');
    var value = '';
    if (selectOption) {
      value = selectOption[0].element.value;
    }
    value === 'Loan - with interest' ? sofWarning.show() : sofWarning.hide();
  },
  /**
  * Checks if any of the affordability questions where answered 'NO'
  * @private
  */
  _checkRequiredQuestionsAnsweredNo: function _checkRequiredQuestionsAnsweredNo() {
    return $('[data-affordability-required-question]').find('input:checked').map(function () {
      return $(this).val();
    }).get().includes('false');
  },
  updatePaymentAjustmentStep: function updatePaymentAjustmentStep(data) {
    var form = document.getElementById('PaymentAdjustmentForm');
    if (form === null || form === undefined) {
      console.error('No form found on page - unable to proceed');
      return;
    }

    //submits a copy of the form in background to store current state for page reload or redirect while signing in to enhanced login
    $.ajax({
      url: form.action,
      method: 'POST',
      data: $(form).serialize() + '&progression=next'
    });
    app.helpers.additionalSecurityRedirect(data);
  },
  /**
  * Rejects existing customer offer
  * @public
  */
  onCustomerOfferRejected: function onCustomerOfferRejected(e) {
    e.preventDefault();
    $('[data-payment-spinner]').show();
    _this = this;
    var form = document.getElementById('CustomerOfferReviewForm');
    var offerState = 'Rejected';
    if (form === null) {
      form = document.getElementById('CustomerOfferAffordabilityForm');
      offerState = 'Unaffordable';
    }

    // If this is ever true then we have a big problem
    if (form === null || form === undefined) {
      console.log('No form found on page - unable to reject');
      return;
    }
    $.ajax({
      url: form.action,
      method: 'POST',
      data: $(form).serialize() + '&progression=' + offerState,
      success: function success(data) {
        if (data === null) {
          console.error('Unable to reject customer offer - the response is null');
          data = {
            hasErrors: true,
            errors: []
          };
          data.errors.push('There was an error rejecting your offer. Please try again later.');
        }
        if (data !== null && data.hasErrors) {
          // Write errors to UI
          var vs = $('[' + _this.attr.validationMessageSummary + ']');
          $(vs).children('ul').empty();
          $.each(data.errors, function (i, item) {
            vs.children('ul').append($('<li></li>').text(item));
          });
          $(vs).addClass('validation-summary-errors');
          $('[data-payment-spinner]').hide();
        }
        if (data !== null && data.redirectUrl !== null && data.redirectUrl !== undefined && data.redirectUrl !== '') {
          console.log(data.redirectUrl);
          window.location = data.redirectUrl;
        }
      }
    });
  },
  onChangeIandEQuestion: function onChangeIandEQuestion() {
    if ($('[' + this.attr.iAndEAnswer + ']:checked').val() == 'true') {
      $('[' + this.attr.iAndEPrompt + ']').show();
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').hide();
    } else {
      $('[' + this.attr.iAndEPrompt + ']').hide();
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').show();
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').removeAttr('disabled');
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').removeClass('disabled');
    }
  },
  onChangeDIQuestion: function onChangeDIQuestion() {
    $('[' + this.attr.affordabilityAssessmentConfirmed + ']').attr('disabled', true);
    $('[' + this.attr.affordabilityAssessmentConfirmed + ']').addClass('disabled');
    if ($('[' + this.attr.diAnswer + ']:checked').val() == 'true') {
      $('[' + this.attr.diAmount + ']').show();
      $('[' + this.attr.customerNotProvidingData + ']').hide();
      $('[' + this.attr.confirmUnableToDetermine + ']').prop('checked', false);
    } else {
      $('[' + this.attr.diAmount + ']').hide();
      $('[' + this.attr.customerNotProvidingData + ']').show();
      $('[' + this.attr.diAmountValue + ']').val('');
    }
  },
  onConfirmAffordability: function onConfirmAffordability(e) {
    e.preventDefault();
    if (!$('[' + this.attr.diQuestion + ']').is(':visible')) {
      $('[' + this.attr.diQuestion + ']').show();
      $('[' + this.attr.iAndEQuestion + ']').hide();
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').attr('disabled', true);
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').addClass('disabled');
      if ($('[' + this.attr.diAnswer + ']:checked').length) {
        this.onChangeDIQuestion();
      }
    } else {
      $('#PaymentAffordabilityAssessmentForm').submit();
    }
  },
  onPreviousAffordability: function onPreviousAffordability(e) {
    e.preventDefault();
    if ($('[' + this.attr.diQuestion + ']').is(':visible')) {
      $('[' + this.attr.diQuestion + ']').hide();
      $('[' + this.attr.iAndEQuestion + ']').show();
      $('[' + this.attr.diAmount + ']').hide();
      $('[' + this.attr.customerNotProvidingData + ']').hide();
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').removeAttr('disabled');
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').removeClass('disabled');
      $('[' + this.attr.confirmUnableToDetermine + ']').prop('checked', false);
      $('[' + this.attr.diAmountValue + ']').val('');
    } else {
      window.location = window.location.origin + '/accounts';
    }
  },
  onChangeDIValue: function onChangeDIValue() {
    if ($('[' + this.attr.diAmountValue + ']').val().length) {
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').removeAttr('disabled');
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').removeClass('disabled');
    } else {
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').attr('disabled', true);
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').addClass('disabled');
    }
  },
  onConfirmUnabletoDetermine: function onConfirmUnabletoDetermine() {
    if ($('[' + this.attr.confirmUnableToDetermine + ']').val() == 'true') {
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').removeAttr('disabled');
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').removeClass('disabled');
    } else {
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').attr('disabled', true);
      $('[' + this.attr.affordabilityAssessmentConfirmed + ']').addClass('disabled');
    }
  },
  onAffordabilityAssessmentSuccess: function onAffordabilityAssessmentSuccess(e) {
    if (e.success) {
      $('#PageSpinner').show();
      location.reload();
    }
  }
});